import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
}             from 'react';
import {
  useLocation,
}             from "react-router-dom";
import useJwt from "hooks/useJwt";
import {
  FormattedMessage,
  useIntl,
}             from 'react-intl';

const ResetPassword = () => {

  const { formatMessage } = useIntl();

  const { search } = useLocation();
  const email_address = useMemo(() => new URLSearchParams(search).get('address'), [search]);
  const [password, setPassword] = useState('');
  const [repeated_password, setRepeatedPassword] = useState('');
  const base64_token = new URLSearchParams(search).get('token');
  const { decoded_token, is_expired } = useJwt(base64_token);

  const {
    min_length,
    test_regexes,
  } = decoded_token?.password_settings || {};

  const errors = test_regexes
    ?.filter(({ regex }) => !new RegExp(regex).test(password))
    .map(({ error }) => error) || [];

  const error_amount = errors.length;

  const submitPassword = useCallback(() => {
    fetch('/reset_password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accepts': 'application/json',
      },
      body: JSON.stringify({
        token: base64_token,
        new_password: password,
      }),
    })
      .then(res => res.ok || res.json().then(({ error }) => Promise.reject(error)))
      .then(() => {
        alert(formatMessage({ defaultMessage: 'Contraseña cambiada correctamente' }));
        window.location = '/';
      })
      .catch(() => alert(formatMessage({ defaultMessage: 'Error al cambiar la contraseña' })));
  }, [password, base64_token, formatMessage]);

  useEffect(() => {
    const onEnter = e => {
      if (e.key === 'Enter') {
        e.stopPropagation();
        if (password === repeated_password && error_amount === 0 && password.length >= min_length)
          submitPassword();
      }
    };

    window.addEventListener('keydown', onEnter);
    return () => window.removeEventListener('keydown', onEnter);
  }, [submitPassword, password, repeated_password, error_amount, min_length]);

  if (is_expired) {
    return (
      <h1>
        <FormattedMessage defaultMessage='El link para el cambio de contraseña ha expirado, vuelve a pedir otro' />
      </h1>
    );
  }

  return (
    <>
      <h1 style={{ flex: 0.25 }}>
        <FormattedMessage defaultMessage='Cambio de contraseña' />
      </h1>
      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          gap: '1em',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '20em',
        }}
      >
        <label>
          <FormattedMessage defaultMessage='Email' />
        </label>
        <input
          type='email'
          placeholder='Email'
          value={email_address}
          disabled
          className='input'
          style={{ padding: '1.5em' }}
        />
        <label>
          <FormattedMessage defaultMessage='Contraseña' />
        </label>
        <input
          type='password'
          placeholder='Contraseña'
          value={password}
          onChange={e => setPassword(e.target.value)}
          className='input'
          style={{ padding: '1.5em' }}
        />
        <label>
          <FormattedMessage defaultMessage='Repite la contraseña' />
        </label>
        <input
          type='password'
          placeholder='Contraseña'
          value={repeated_password}
          onChange={e => setRepeatedPassword(e.target.value)}
          className='input'
          style={{ padding: '1.5em' }}
        />
        <button
          className='button-primary button-medium'
          style={{ width: '100%' }}
          disabled={password !== repeated_password || errors.length > 0 || password.length < min_length}
          onClick={() => submitPassword()}
        >
          <FormattedMessage defaultMessage='Cambiar contraseña' />
        </button>
        {password !== repeated_password && (
          <div style={{ color: Colors.accent_6, alignSelf: 'flex-start' }}>
            <FormattedMessage defaultMessage='Las contraseñas no coinciden' />
          </div>
        )}
        {errors.map(error => (
          <div style={{ color: Colors.accent_6, alignSelf: 'flex-start' }}>
            {error}
          </div>
        ))}
        {password.length < min_length && (
          <div style={{ color: Colors.accent_6, alignSelf: 'flex-start' }}>
            <FormattedMessage defaultMessage='La contraseña debe tener al menos {min_length} caracteres' values={{ min_length }} />
          </div>
        )}
      </div>
    </>
  );
};

export default ResetPassword;
